import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Button, Spinner, Card, Grid, Divider, Heading, Flex,
} from '@oliasoft-open-source/react-ui-library';
import { getRaw } from 'client/store/entities/object/object';
import stringify from 'json-stringify-pretty-compact';
import { RecongnizebleFileFormats } from 'common/enums/known-data-enums';
import JSONPretty from 'react-json-pretty';
import JSONPrettyMon from 'react-json-pretty/dist/monikai';
import { useTranslation } from 'react-i18next';
import translations from 'client/internationalization/translation-map.json';
import { getAllNodes } from 'client/store/entities/node/node';
import { IObject } from 'common/interfaces/hierarchy-entities';

interface JSONViewerProps {
  dataObject: IObject;
  raw: any;
  isLoading: boolean,
  getRaw: Function;
}

// TODO: rename to item viewer
const JSONViewer = ({
  dataObject, raw, getRaw, isLoading,
}: JSONViewerProps) => {
  const [jsonButton, setJsonButton] = useState(false);
  const [rawData, setRawData] = useState<any>();
  const isEdm = dataObject?.metadata?.file?.fileType === RecongnizebleFileFormats.Edm;

  const { t } = useTranslation();

  useEffect(() => {
    if (!dataObject.data && dataObject.metadata.blobData.blobName) {
      setJsonButton(true);
    }
  }, [dataObject]);

  useEffect(() => {
    if (raw) {
      setRawData(raw);
    }
  }, [raw]);

  const getJsonFromBlob = () => {
    getRaw(dataObject.metadata.blobData.blobName);
    setJsonButton(false);
  };

  const jsonRenderer = (data: object) => (
    <div style={{ maxHeight: '60vh', overflow: 'auto' }}>
      {(isEdm && !dataObject.data) ? (<pre>{stringify(data, { maxLength: 100 })}</pre>) : <JSONPretty data={data} theme={JSONPrettyMon} />}
    </div>
  );

  const pdfTextRenderer = () => (<div style={{ maxHeight: '60vh', overflow: 'auto' }}><pre>{rawData.pdf}</pre></div>);

  const rawRenderer = () => (
    <>
      <Grid columns="100%">
        {jsonButton && <Button label={t(translations.viewer_loadJson)} onClick={getJsonFromBlob} />}
      </Grid>
      <Divider margin={0} />
      {!jsonButton && (isLoading || !rawData) && <Flex justifyContent="center" alignItems="center"><Spinner dark /></Flex>}
      {!jsonButton && !isLoading && rawData?.pdf && pdfTextRenderer()}
      {!jsonButton && !isLoading && !rawData?.pdf && jsonRenderer(rawData)}
    </>
  );

  return (
    <Card
      heading={<Heading>{dataObject?.metadata?.file?.name || dataObject.name}</Heading>}
      padding={false}
    >
      {dataObject?.data
        ? jsonRenderer(dataObject.data)
        : rawRenderer()}
    </Card>
  );
};

const mapStateToProps = ({ entities }: { entities: any }) => ({
  raw: entities?.object.raw,
  isLoading: entities?.object.isLoadingRaw,
  nodes: entities?.node.nodes,
  isNodesLoading: entities?.node.isLoading,
});

const mapDispatchToProps = {
  getRaw,
  getAllNodes,
};

const Container = connect(mapStateToProps, mapDispatchToProps)(JSONViewer);

export { Container as JSONViewer };
